<template>
    <VForm
        v-slot="{ form }"
        :on-submit-async="submit"
        @success="(value)=>this.$emit('success',value)">
        <BundleCouponCreateAndUpdateFormItems :form="form" />
    </VForm>
</template>
<script>
import { rootActions } from '@/store/types'
import VForm from '@/components/VForm.vue'
import BundleCouponCreateAndUpdateFormItems from '@/components/BundleCouponCreateAndUpdateFormItems.vue'

export default {
    components: {
        VForm,
        BundleCouponCreateAndUpdateFormItems,
    },
    methods: {
        async submit (values) {
            const res = await this.$store.dispatch(
                rootActions.ADD_BUNDLE_COUPON, { ...values },
            )
            return res
        },
    },
}
</script>
